import React from 'react';

import LinkIcon from '@mui/icons-material/Link';
import TblIcon from '@mui/icons-material/TableChart';
import convert from 'react-from-dom';

import { useTooltip } from './TooltipContext';

export default ({ frmId, classes, group, jelData, rowIndex, groupIndex, filteredViews, openTrplFormFull }) => {
  const { registerRef } = useTooltip();

  return (
  <div key={groupIndex} className={`${classes.fw}`}>
    {group.title && <div className={classes.groupHeading}>{group.title}</div>}

    <div style={{ padding: '10px'}}>
      {group && group.links
        ? group.links.map((link, linkIndex) => {
          if (link && link.hidden) return null;

          const linkTitle =
            link.title ||
            (jelData[link.jel] && jelData[link.jel].title ? jelData[link.jel].title : '') ||
            link.url;

          const viewDoesntExist = link.jel && !jelData[link.jel];
          
          const isTblOrFrm =
            link.jel && jelData[link.jel] && jelData[link.jel].type === 'table' ? (
              <TblIcon className={classes.dashboardLinkIcon} style={{ color: '#DE3939' }} />
            ) : link.jel && jelData[link.jel] && jelData[link.jel].type === 'form' ? (
              <img src="/images/ui-edit-frm.svg" alt="ui-edit-frm" style={{ width: '13px', paddingRight: '1px' }} />
            ) : (
              <LinkIcon className={classes.dashboardLinkIcon} style={{ color: '#F2994A' }} />
            );

          if (filteredViews && !filteredViews.linkLocations.includes('' + frmId + rowIndex + groupIndex + linkIndex))
          return null;

          let linkUrl = (link.jel && link.jel !== 'none') ? `http://${window.location.host}/frm?id=${link.jel}` : link.url;

          if (link.jel && link.jel !== 'none' && link.view_filters) linkUrl = `${linkUrl}&filters=${JSON.stringify(link.view_filters)}`;
          if (link.jel && link.jel !== 'none' && link.view_sorter) linkUrl = `${linkUrl}&sorter=${JSON.stringify(link.view_sorter)}`;

          const linkAttrs = {};

          let domain = '';

          if (linkUrl[0] === '/') {
            linkUrl = `http://${window.location.host}${linkUrl}`;

            domain = window.location.host;
          } else if (new RegExp(`http://`).test(linkUrl)) {
            domain = linkUrl.replace('http://', '');

            if (domain.includes('/')) {
              domain = domain.substring(0, domain.indexOf('/'));
            }
          } else if (new RegExp(`https://`).test(linkUrl)) {
            domain = linkUrl.replace('https://', '');

            if (domain.includes('/')) {
              domain = domain.substring(0, domain.indexOf('/'));
            }
          } else if (new RegExp('www.').test(linkUrl)) {
            domain = linkUrl.replace('www.', '');

            if (domain.includes('/')) {
              domain = domain.substring(0, domain.indexOf('/'));
            }
          } else {
            domain = linkUrl.substring(0, linkUrl.indexOf('/'));
          }

          const isMlkwbLink = domain === window.location.host;

          const viewJelData = jelData[link.jel];

          let graphFilterIdsObj = {};

          for (let key in link) {
            if (key.startsWith('graph_filter_id')) {
              graphFilterIdsObj[key] = link[key];
            }
          }
          
          if (viewJelData && !link.target && viewJelData.type === 'form') {
            return (
              <div
                key={linkIndex}
                className={`${classes.dashboardLink} ${classes.pointer}`}
                onClick={()=> {
                  openTrplFormFull({
                    concept: viewJelData.concept,
                    groups: viewJelData.groups,
                    title: viewJelData.title,
                    formId: viewJelData.id,
                    form: viewJelData,
                    mode: 'create',
                    tabs: viewJelData.tabsTitles || [],
                    graph_filter_id: link.graph_filter_id,
                    graphFilterIdsObj,
                  })
                }}
              >
                <span 
                  ref={registerRef(`${link.jel}`)}
                >{linkTitle}</span>

                {viewDoesntExist ? <span style={{ color: 'red', fontSize: 10 }}>{link.jel} Deleted</span> : isTblOrFrm}
              </div>
            );

          } else {
            if (link.target || !isMlkwbLink) {
              linkAttrs.target = '_blank';
              linkAttrs.rel='noreferrer noopener';
              linkUrl = `${linkUrl}`;
            }

            return (
              <a
                ref={registerRef(`${link.jel}`)}
                {...linkAttrs}
                href={linkUrl}
                key={linkIndex}
                className={classes.dashboardLink}
              >
                <span>{linkTitle}</span>

                {viewDoesntExist ? <span style={{ color: 'red', fontSize: 10 }}>{link.jel} Deleted</span> : isTblOrFrm}
              </a>
            );
          }
        })
      : group && group.items ? group.items.map((item, index) => {
        return (
          <div className={classes.m10} key={index}>
            {item.custom_component && item.custom_component.map((row, rowIndex) => {
              return (
                <div className={`${classes.flex} ${rowIndex > 0 ? classes.mt10 : ''}`} key={rowIndex}>
                  {row && row.children.map((column, columnIndex) => {
                    return (
                      <div key={columnIndex} className={columnIndex > 0 ? classes.ml5 : ''}>
                        {column && column.children.map((item, index) => {
                          return (
                            <div key={index}>
                              {item.type === 'text' ?
                                <div style={{ fontSize: '11px', margin: '2px' }}>{convert(item.value)}</div>
                              : null}
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )
        })
      : null}
    </div>
  </div>
)};
